import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute left-0 right-0 z-30 mt-1 overflow-y-auto border shadow-lg rounded-xl custumScroll border-secondary bg-[#252b38]",
  style: {"max-height":"240px"}
}
const _hoisted_2 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-400"
}
const _hoisted_3 = ["onMousedown"]
const _hoisted_4 = { class: "text-accent" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs text-gray-400"
}
const _hoisted_6 = {
  key: 0,
  class: "px-3 py-2 text-sm text-amber-400"
}

import { ref, computed } from "vue";

	/**
	 * Champ de recherche rapide avec menu de suggestions (typeahead).
	 *
	 * Composant PRÉSENTATIONNEL : le debounce, l'appel réseau et la garde
	 * anti-obsolescence vivent dans le composable `useQuickSearch` côté
	 * parent. Ici on émet seulement le terme saisi (`@search`) et
	 * l'élément choisi (`@select`). Réutilisable pour n'importe quelle
	 * ressource (clients, colis, billets…).
	 *
	 * Props :
	 *   results       : liste de suggestions (objets quelconques)
	 *   labelField    : clé du libellé principal dans chaque suggestion
	 *   sublabelField : clé du sous-libellé (téléphone, référence…)
	 *   loading       : recherche en cours
	 *   searched      : une recherche a abouti (pour afficher "aucun résultat")
	 */
	
export default /*#__PURE__*/_defineComponent({
  __name: 'AutocompleteTag',
  props: {
		placeholder: { type: String, default: "Rechercher…" },
		results: { type: Array as () => any[], default: () => [] },
		loading: { type: Boolean, default: false },
		searched: { type: Boolean, default: false },
		labelField: { type: String, default: "label" },
		sublabelField: { type: String, default: "sublabel" },
		notFoundText: { type: String, default: "Aucun résultat." },
		minChars: { type: Number, default: 2 },
	},
  emits: ["search", "select"],
  setup(__props, { emit: __emit }) {

	const props = __props;

	const emit = __emit;

	const term = ref("");
	const open = ref(false);

	const onType = (value: any) => {
		term.value = (value ?? "").toString();
		open.value = true;
		emit("search", term.value);
	};

	const choose = (item: any) => {
		term.value = (item?.[props.labelField] ?? "").toString();
		open.value = false;
		emit("select", item);
	};

	// Fermeture après blur — léger délai pour laisser le clic sur un
	// item (mousedown) se déclencher avant que le menu ne disparaisse.
	const onFocusOut = () => {
		setTimeout(() => (open.value = false), 180);
	};

	const showDropdown = computed(
		() => open.value && term.value.trim().length >= props.minChars,
	);

return (_ctx: any,_cache: any) => {
  const _component_InputTag = _resolveComponent("InputTag")!

  return (_openBlock(), _createElementBlock("div", {
    class: "relative",
    onFocusout: onFocusOut
  }, [
    _createVNode(_component_InputTag, {
      placeholder: __props.placeholder,
      type: "text",
      value: term.value,
      onModel: onType
    }, null, 8, ["placeholder", "value"]),
    (showDropdown.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Recherche…"))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.results, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "px-3 py-2 border-b cursor-pointer border-[#374151] hover:bg-[#374151]",
                    onMousedown: _withModifiers(($event: any) => (choose(item)), ["prevent"])
                  }, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(item[__props.labelField]), 1),
                    (item[__props.sublabelField])
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(item[__props.sublabelField]), 1))
                      : _createCommentVNode("", true)
                  ], 40, _hoisted_3))
                }), 128)),
                (__props.searched && __props.results.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.notFoundText), 1))
                  : _createCommentVNode("", true)
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})